import { PaginatedResponse } from '@/types/Common'

/**
 * Reusable helper to extract the 'page' number from a DRF next/previous URL.
 * It uses window.location.origin as a fallback to handle relative URLs safely.
 */
export const getNextPageParamHelper = (lastPage: PaginatedResponse<unknown>): number | undefined => {
  if (!lastPage.next) return undefined

  try {
    const url = new URL(lastPage.next, window.location.origin)
    const page = url.searchParams.get('page')
    return page ? parseInt(page, 10) : undefined
  } catch (error) {
    return undefined
  }
}
